import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import GeneralStatusReport from './GeneralStatusReport.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import VoiceCallDashboard from './VoiceCallDashboard.vue';

const AutoAssignAudit = () => import('./AutoAssignAudit.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['reports.overview.view'],
};

const reportMeta = permission => ({
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: [permission],
});

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta: reportMeta('reports.agents.view'),
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta: reportMeta('reports.inboxes.view'),
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta: reportMeta('reports.labels.view'),
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta: reportMeta('reports.teams.view'),
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['reports.agents.view'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['reports.agents.view'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['reports.inboxes.view'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['reports.inboxes.view'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['reports.teams.view'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['reports.teams.view'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['reports.labels.view'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['reports.labels.view'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'voice-calls',
          name: 'voice_call_dashboard',
          meta,
          component: VoiceCallDashboard,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta: reportMeta('reports.conversations.view'),
          component: GeneralStatusReport,
        },
        {
          path: 'sla_violations',
          name: 'sla_violations_report',
          meta: reportMeta('reports.sla_violations.view'),
          component: () => import('./SlaViolationsReport.vue'),
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'csat',
          name: 'csat_reports',
          meta: reportMeta('reports.csat.view'),
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta: reportMeta('reports.bot.view'),
          component: BotReports,
        },
        {
          path: 'auto_assign_audit',
          name: 'auto_assign_audit_reports',
          // Restricted to developer/manager roles by the Buzzer permission registry.
          meta: {
            permissions: ['reports.auto_assignment_audit.view'],
          },
          component: AutoAssignAudit,
        },
        {
          path: 'pending_actions',
          name: 'pending_actions_reports',
          // Restricted to developer/manager roles by the Buzzer permission registry.
          meta: {
            permissions: ['reports.pending_actions.view'],
          },
          component: () => import('./PendingActions.vue'),
        },
        {
          path: 'raw/agents',
          name: 'raw_agents_report',
          meta: {
            permissions: ['reports.agents.view'],
          },
          component: () => import('./RawAgentsReport.vue'),
        },
        {
          path: 'raw/conversations',
          name: 'raw_conversations_report',
          meta: {
            permissions: ['reports.conversations.view'],
          },
          component: () => import('./RawConversationsReport.vue'),
        },
      ],
    },
  ],
};
